import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysEditorComponent } from './genesys-editor.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ngfModule } from 'angular-file';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { GenesysInsertImageComponent } from './genesys-insert-image/genesys-insert-image.component';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    SvgIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    ngfModule,
    NgbTooltipModule
  ],
  declarations: [
    GenesysEditorComponent,
    GenesysInsertImageComponent
  ],
  exports: [
    GenesysEditorComponent
  ]
})
export class GenesysEditorModule {}
